/* eslint-disable angular/controller-name */
angular.
module("dx.webapp.support").
controller("SupportRouteController", function SupportRouteController(
	$http,

	dxDialog,
	dxSession,
	dxKayako,
	faults,
	dxLocalize,
	RoleTypeEnum
) {
	"use strict";

	var self = this;
	if (dxLocalize.getLanguage() === "sv") {
		self.supportLinks = {
			knowledgeCenter: "https://digiexam.zendesk.com/hc/sv",
			faq: "https://digiexam.zendesk.com/hc/sv/categories/200861585-FAQ",
		};
	} else {
		self.supportLinks = {
			knowledgeCenter: "https://digiexam.zendesk.com/hc/en-us",
			faq: "https://digiexam.zendesk.com/hc/en-us/categories/200861585-FAQ",
		};
	}

	self.installationLinks = {
		toolbox: "https://storage.googleapis.com/digiexam_builds/DigiexamToolbox_1.3.87.msi",
		win64: "https://cdn.crabnebula.app/download/digiexam/digiexam/latest/platform/wix-x86_64",
		winArm: "https://cdn.crabnebula.app/download/digiexam/digiexam/latest/platform/wix-aarch64",
		mac: "https://cdn.crabnebula.app/download/digiexam/digiexam/latest/platform/dmg-universal",
		chromebook: "https://support.digiexam.se/hc/en-us/articles/202305421-Installation-guide-Managed-Chromebooks",
		ipad: "https://apps.apple.com/se/app/digiexam/id1033106203",
	};

	var salesEmails = {
		sv: "carl.nardini@digiexam.se",
		en: "carl.nardini@digiexam.com",
		fi: "carl.nardini@digiexam.com",
	};

	var supportEmails = {
		sv: "support@digiexam.se",
		en: "support@digiexam.com",
		fi: "support@digiexam.com",
	};

	self.RoleTypeEnum = RoleTypeEnum;
	self.roleType = dxSession.getRole().roleType;

	self.eligibleSupport = false;
	self.supportEligibleRequestDone = false;

	self.userId = dxSession.getUser().id;

	var salesEmail = salesEmails[dxLocalize.getLanguage()];
	var supportEmail = supportEmails[dxLocalize.getLanguage()];
	var mailToSubject = encodeURIComponent(dxLocalize.get("Support.SalesMailSubject"));
	var mailToBody = encodeURIComponent(dxLocalize.get("Support.SalesMailBody"));
	var mailToLinkSales = "mailto:{0}?subject={1}&body={2}".format(salesEmail, mailToSubject, mailToBody);
	var mailToLinkSupport = "mailto:{0}".format(supportEmail);
	self.descriptionNonPaying = dxLocalize.get("Support.ThisSupportFeatureIsOnly").format(mailToLinkSales, salesEmail);
	self.descriptionPaying = dxLocalize.get("Support.NeedMoreHelp.EmailUs").format(mailToLinkSupport, supportEmail);

	self.showGettingStartedGuidePopup = function showGettingStartedGuidePopup() {
		dxDialog.show({
			templateUrl: "/partials/popups/getting-started-guide.html",
		});
	};

	self.openKayakoChat = function openKayakoChat() {
		dxKayako.toggleChat();
	};

	function requestSupportEligible() {
		$http({url: "/support/eligible/", method: "GET"}).then(supportEligible, supportNotEligible);

		function supportEligible(response) {
			if (response.data && response.data.faults[0] === faults.FORBIDDEN) {
				supportNotEligible();
			} else {
				self.eligibleSupport = true;
				self.supportEligibleRequestDone = true;
				dxKayako.show();
			}
		}

		function supportNotEligible() {
			self.eligibleSupport = false;
			self.supportEligibleRequestDone = true;
			dxKayako.hide();
		}
	}

	requestSupportEligible();
});
